import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = ["onClick"]

import { UiInput, UiFormField } from '@klausapp/ui-kit'
import { PlusIcon, MinusIcon } from '@klausapp/ui-kit/icons'
import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MultirowTextInput',
  props: {
    modelValue: {},
    errors: {}
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const internalRows = ref(props.modelValue?.length ? props.modelValue : [''])

watch(
  internalRows,
  () => {
    const filtered = internalRows.value.map((v) => v.trim()).filter((v) => !!v)
    emit('update:model-value', filtered.length ? filtered : undefined)
  },
  { deep: true },
)

const updateRow = (e: string, i: number) => {
  internalRows.value[i] = e
}

const removeRow = (i) => {
  internalRows.value = internalRows.value.filter((_, j) => j !== i)
}

const addRow = () => {
  internalRows.value = [...internalRows.value, '']
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(internalRows.value, (row, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        _createVNode(_unref(UiFormField), {
          error: _ctx.errors?.[i]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(UiInput), {
                "model-value": row,
                error: !!_ctx.errors?.[i],
                type: "text",
                small: "",
                "onUpdate:modelValue": ($event: any) => (updateRow($event, i))
              }, null, 8 /* PROPS */, ["model-value", "error", "onUpdate:modelValue"]),
              (internalRows.value.length !== 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "bg-gray-10 hover:bg-gray-20 flex h-8 cursor-pointer items-center justify-center rounded-md px-2 py-1 duration-200 ease-out",
                    onClick: ($event: any) => (removeRow(i))
                  }, [
                    _createVNode(_unref(MinusIcon), { class: "h-4 w-4" })
                  ], 8 /* PROPS */, _hoisted_3))
                : _createCommentVNode("v-if", true),
              (i === internalRows.value.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "bg-gray-10 hover:bg-gray-20 flex h-8 cursor-pointer items-center justify-center rounded-md px-2 py-1 duration-200 ease-out",
                    onClick: addRow
                  }, [
                    _createVNode(_unref(PlusIcon), { class: "h-4 w-4" })
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["error"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})